module.exports = __webpack_public_path__ + "static/media/pro.75b543af.png";